import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from '@app/app.module';
import config from '@config';
import { DateUtility } from '@shared/date-utility';
import 'leaflet';
import 'leaflet.markercluster';

DateUtility.MILLISECONDS_FIXED_DATE = config.fixedDateMs;

if (config.production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err));
